(function () {
    'use strict';

    angular
        .module('notificationsPlatform')
        .controller('NotificationsController', NotificationsController)

    NotificationsController.$inject = ['$uibModal', 'NotificationsPlatformService', 'VirtualFairService'];


    function NotificationsController($uibModal, NotificationsPlatformService, VirtualFairService) {
        var vm = this;

        vm.queryFlag                    = false;
        vm.expos                        = [];
        vm.expoSelected                 = -1;
        vm.selectExpos                  = selectExpos;
        vm.createNotification           = createNotification;
        vm.getAllNotifications          = getAllNotifications;
        vm.getAllGeneralNotifications   = getAllGeneralNotifications;
        vm.createGeneralNotificaton     = createGeneralNotificaton;
        vm.useNotification              = useNotification;
        vm.tab                          = 'sent';
        vm.tabChange                    = tabChange;
        vm.getGeneralFilters            = getGeneralFilters;
        vm.getTargetName                = getTargetName;

        vm.targetOptions = [
            {id: 'all', name: 'All targets'},
            {id: 'allUsers', name: 'All users'},
            {id: 'visitor', name: 'For students'},
            {id: 'representative', name: 'For exhibitors'}
        ];
        vm.languageOptions = [
            {id: 'all', name: 'All'},
            {id: 'en', name: 'English'},
            {id: 'pt', name: 'Portuguese'},
            {id: 'es', name: 'Spanish'},
            {id: 'tr', name: 'Turkish'},
        ];
        vm.whenOptions = [
            {id: 'all', name: 'All'},
            {id: 'start', name: 'Start'},
            {id: 'during', name: 'During'},
            {id: 'near-and-at-end', name: 'Near and at end'},
            {id: 'there-talks', name: 'If there area talks'},
        ]
        vm.generalFilters = {
            target: 'all',
            language: 'all',
            when: 'all'
        }
        vm.totalItems                   = 0;
        vm.notifications                = [];
        vm.generalNotifications         = [];
        vm.funFacts                     = [];
        vm.totalGeneralItems            = 0;


        function activate() {
            vm.selectExpos();
        }

        function tabChange(value) {
            vm.tab = value;
        }

        function getTargetName(target){
            return vm.targetOptions.find(t => t.id === target).name
        }

        function getGeneralFilters(item){
            let searchTerms = {
                target: {
                    op: vm.generalFilters.target === 'all' ? '!==' : '===',
                    value: vm.generalFilters.target === 'all' ? '' : vm.generalFilters.target === 'allUsers' ? 'all' : vm.generalFilters.target
                },
                language: {
                    op: vm.generalFilters.language === 'all' ? '!==' : '===',
                    value: vm.generalFilters.language === 'all' ? '' : vm.generalFilters.language
                },
                when: {
                    op: vm.generalFilters.when === 'all' ? '!==' : '===',
                    value: vm.generalFilters.when === 'all' ? '' : vm.generalFilters.when
                },
            }
            const searchString = `item.target ${searchTerms.target.op} '${searchTerms.target.value}' && item.language.id ${searchTerms.language.op} '${searchTerms.language.value}' && item.when.id ${searchTerms.when.op} '${searchTerms.when.value}'`
            return eval(searchString)
        }

        function selectExpos () {
            NotificationsPlatformService.getAllExpos().then(function(response){
                vm.expos = response.data;
            });
        }

        function getAllNotifications() {
            NotificationsPlatformService.getAllNotifications(vm.expoSelected).then(function(response){
                vm.queryFlag = true
                vm.notifications = response.data
                vm.to         = response.data.length
                vm.totalItems = response.data.length
            })
            NotificationsPlatformService.getAllGeneralNotifications().then(function(response){
                vm.generalNotifications = response.data.map(gn => ({
                    ...gn,
                    when: vm.whenOptions.find(l => l.id === gn.when),
                    language: vm.languageOptions.find(l => l.id === gn.language)
                }))
                vm.totalGeneralItems = response.data.length
            })
            VirtualFairService.getQuestions(vm.expoSelected).then(function(response){
                vm.funFacts = response.data;
            })
        }

        function getAllGeneralNotifications(){
            NotificationsPlatformService.getAllGeneralNotifications().then(function(response){
                vm.generalNotifications = response.data.map(gn => ({
                    ...gn,
                    when: vm.whenOptions.find(l => l.id === gn.when),
                    language: vm.languageOptions.find(l => l.id === gn.language)
                }))
                vm.totalGeneralItems = response.data.length
            })
        }

        function createNotification(generalNotification) {
            $uibModal.open({
                templateUrl: "templates/notifications/form/form.modal.html",
                controller: "NotificationsFormController",
                controllerAs: "vm",
                resolve: {
                    virtualfair: () => {
                        return vm.expoSelected;
                    },
                    generalNotification: () => {
                        if(generalNotification){
                            return {
                                eventId: vm.expoSelected,
                                target: generalNotification.target,
                                exhibitorId: null,
                                content: generalNotification.content

                            }
                        }

                    }
                },
            }).result.then(function(data){
                vm.getAllNotifications();
            });
        }

        function createGeneralNotificaton(generalNotification){
            $uibModal.open({
                templateUrl: "templates/notifications/form/general.modal.html",
                controller: "NotificationsGeneralFormController",
                controllerAs: 'vm',
                resolve: {
                    notification: () =>  {
                        return generalNotification
                    }
                }
            }).result.then(function(data){
                vm.getAllGeneralNotifications();
            });
        }

        function useNotification(id, content){
            if(!id && !content.length) return
            const notificationSelected = id ? vm.generalNotifications.find(nt => nt.id === id) : {
                target: 'visitor',
                content: content
            }
            createNotification(notificationSelected)
        }
        activate();
    }

})();